exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FbaTvT3R3pWAOyNe03mAE{display:block}", ""]);

// exports
exports.locals = {
	"submit": "FbaTvT3R3pWAOyNe03mAE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/social-buttons/social-buttons.css
// module id = 290
// module chunks = 0 1 2